import { TbBriefcase, TbBuildingHospital, TbEdit, TbHexagon, TbHospital } from "react-icons/tb";

import { CommonStatusItem, NotificationCategories } from "@/types/global";

import { softColors } from "./colors";

export type NotificationCategoryItem = CommonStatusItem & {
    value: NotificationCategories;
};

export type NotificationCategoryList = NotificationCategoryItem[];

export const notificationCategories: NotificationCategoryList = [
    {
        value: NotificationCategories.SHIFT_OPERATIONS,
        component: () => TbBriefcase,
        ...softColors.green,
        tooltip: {
            title: "Mesai İşlemleri",
            description: "Mesai işlemlerini içeren bildirimleri içerir.",
        },
    },
    {
        value: NotificationCategories.OPERATION_SERVICE_UPDATE,
        component: () => TbEdit,
        ...softColors.indigo,
        tooltip: {
            title: "Operasyon Hizmeti",
            description: "Operasyon hizmeti içeren bildirimleri içerir.",
        },
    },
    {
        value: NotificationCategories.UHM_PASSENGER_UPDATE,
        component: () => TbHospital,
        ...softColors.red,
        tooltip: {
            title: "UHM Yolcu",
            description: "UHM yolcu içeren bildirimleri içerir.",
        },
    },
    {
        value: NotificationCategories.HOTEL_CLINIC_REQUEST,
        component: () => TbBuildingHospital,
        ...softColors.teal,
        tooltip: {
            title: "Hastane-Otel",
            description: "Hastane-otel taleplerini içeren bildirimleri içerir.",
        },
    },
    {
        value: NotificationCategories.OTHERS,
        component: () => TbHexagon,
        ...softColors.blue,
        tooltip: {
            title: "Diğer",
            description: "Geriye kalan bildirimleri  içeren bildirimleri içerir.",
        },
    },
];
